import React from 'react'
import { TABLE_TYPE, withTableContext } from '../../context/TableContext'
import { EKOM_LINKS } from '../../EKOM_LINKS'
import { useContractsSlug } from '../../hooks/useContractsSlug'
import { useSubmissionsList } from '../../hooks/useSubmissionsList'
import { EKOM_STATES_LABEL, EKOM_TYPES_LABEL } from '../../utils/enums'
import { findLink } from '../../utils/findLink'
import { MsgsTable } from '../MsgsTable/MsgsTable'

const MsgsSubmissionsList = () => {

  const heads = [
    { id: 'deliveredAt', label: 'Datum ' },
    { id: 'state', label: '' },
    { id: 'type', label: 'Typ' },
    { id: 'objectName', label: 'Zadávací postup' },
    { id: 'recipientOrganizationName', label: 'Příjemce' },
  ]

  const { data, error, loading, totalCount } = useSubmissionsList()
  const { data: slugData } = useContractsSlug(data)

  const tableData = data.map(msg => ({
    id: msg.id,
    deliveredAt: msg.deliveredAt,
    type: EKOM_TYPES_LABEL[msg.type],
    state: EKOM_STATES_LABEL[msg.state],
    link_type: EKOM_LINKS.listSubmissions + '/' + msg.id,
    recipientOrganizationName: msg.recipientOrganizationName,
    objectName: msg.objectName,
    link_objectName: findLink(msg, slugData),
    isRead: true,
    systemExtId: msg.systemExtId,
    objectExtId: msg.objectExtId
  }))

  return (
    <MsgsTable
      loading={loading}
      error={error}
      heads={heads}
      data={tableData}
      totalCount={totalCount}
    />
  )
}

export default withTableContext(MsgsSubmissionsList, TABLE_TYPE.SUBM)
